import 'style-loader!./slide4.component.scss';
import { Component, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { User, Task, PuntoDiVendita, Copy, PDV } from 'app/theme/models/user.model';
import { UserService } from 'app/theme/services/user.service';
import { AlertService } from 'app/theme/services/alert.service';
import { ChannelService } from 'app/theme/services/channel.service';
import { LanguageService } from 'app/theme/services/language.service';
import { DataService } from 'app/theme/services/data.service';
import { MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogService } from 'app/theme/services/dialog.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ElementRef, ViewChild } from '@angular/core';


@Component({
  selector: 'reg-slide4',
  templateUrl: './slide4.component.html',
  encapsulation: ViewEncapsulation.None
})
export class InterestComponent implements OnInit {
  //output
  @Output('submittedInterests') interest: EventEmitter<boolean> = new EventEmitter()

  //data 
  user: User;
  premiList: Array<any> = [];
  preferitoList: Array<any> = [];
  driveList: Array<any> = [];
  favoriteMethod: any;
  EmailExist: boolean;
  disabeldPremi: boolean;
  AcceptGDPRAgreement: boolean;
  Labels: any;
  alerts: any;
  task: Task;
  source: string;
  pathFile = "./assets/data/Informativa_trattamento_dati_03_2021.pdf";
  pathFileProd = "https://profilo.bennet.com/app/assets/data/Informativa_trattamento_dati_03_2021.pdf";
  pathFileBC = "./assets/data/regolamento_carta_bennet_club_2024.pdf";
  pathFileProdBC = "https://profilo.bennet.com/app/assets/data/regolamento_carta_bennet_club_2024.pdf";

  constructor(
    protected _userService: UserService,
    protected _dataService: DataService,
    protected _alertService: AlertService,
    protected _channelService: ChannelService,
    protected _langService: LanguageService,
    protected _dialogService: DialogService,
    iconReg: MatIconRegistry,
    sanitizer: DomSanitizer,
  ) {
    iconReg.addSvgIcon("info", sanitizer.bypassSecurityTrustResourceUrl('./assets/icon/icon_info.svg'))

  }
  /* see(){
     console.log(this.user)
   }*/



    //CR ACCESSIBILITà GESTIONE AUTOCOMPLETE START
    ngAfterViewInit() {
      const fields = ['cap', 'city', 'province', 'address', 'civico','via'];
      const disableForAll = this.source === 'tablet' || this.source === 'totem' || this.source === 'tablet-new' || this.source === 'totem-new';
      
      if (disableForAll) {
          // Converte NodeList in un array e applica la funzione
          Array.from(document.querySelectorAll('input')).forEach((input: HTMLInputElement) => {
          this.disableAutocomplete(input.id); // Usa l'id se disponibile
          });
      
      } else {
          // Disattiva solo per i campi specificati
          fields.forEach(field => this.disableAutocomplete(field));
      }
      }
    
  
      private disableAutocomplete(elementId: string): void {
          const inputElement = document.getElementById(elementId) as HTMLInputElement;
          let sottostringa = "mat-";        

          if (!elementId.toLowerCase().includes(sottostringa.toLowerCase())) {
              if (inputElement) {
                  // Disattiva tutti gli attributi legati all'autocomplete
                  inputElement.setAttribute('autocomplete', 'new-password'); // Alternativa più efficace a "off"
                  inputElement.setAttribute('autocorrect', 'off');
                  inputElement.setAttribute('autocapitalize', 'off');
                  inputElement.setAttribute('spellcheck', 'false');
                  
                  // Cambia dinamicamente il nome e l'ID per evitare suggerimenti memorizzati
                  const newName = elementId + '_' + new Date().getTime();
                  inputElement.setAttribute('name', newName);
                  inputElement.setAttribute('id', newName);
      
                  // Disattiva la gestione automatica degli indirizzi di Chrome e password manager
                  inputElement.setAttribute('data-lpignore', 'true'); // LastPass
                  inputElement.setAttribute('data-form-type', 'other');
                  inputElement.setAttribute('aria-autocomplete', 'none');
              
                    // Nasconde suggerimenti tramite CSS inline
                    // inputElement.style.setProperty('display', 'inline-block', 'important');
                    inputElement.style.setProperty('position', 'relative', 'important');
                    inputElement.style.setProperty('z-index', '9', 'important'); //Abbastanza da sovrapporre i campi non abbastanza da sovrapporre il resto
                  
                  // Ritarda la modifica dell'ID per "ingannare" il browser
                  setTimeout(() => {
                      inputElement.setAttribute('id', elementId);
                  }, 1000);  
              }              
          }
      }  

      @ViewChild('mainContent') mainContent: ElementRef | null = null;
      skipToMain(event: Event) {
          event.preventDefault(); // Evita il comportamento predefinito del link
          
          if (this.mainContent) {
            setTimeout(() => {
              this.mainContent.nativeElement.focus();
            }, 0); // Timeout per garantire che Angular abbia reso l'elemento visibile
          }
        }
  //CR ACCESSIBILITà GESTIONE AUTOCOMPLETE END
			

  ngOnInit() {

    this.disabeldPremi = false;
    this.AcceptGDPRAgreement = false;
    this._userService.getUser()
      .subscribe((user: User) => {
        if (user) {
          this.user = Copy(user);
          this.EmailExist = (this.user.contacts.email) ? true : false;
        }
      })

    this._channelService.getTask().subscribe((task: Task) => {
      this.task = task;
      if (task == Task.RegistratiConBC) {
        this.disabeldPremi = true;

      }
    })
    this._channelService.getSource()
      .subscribe(source => {
        if (source) {
          this.source = source
          if (source != 'drive') {
            this.driveList = [{ "codPdvDrive": null, "descriptionPdvDrive": null }, ...this.preferitoList]
          }
        }
      })

    this._channelService.getSource().subscribe((source: string) => {
      if (source) {
        this.source = source;
      }
    })

    this._langService.translatePageIndex(7).subscribe((mylabels) => {
      this.Labels = mylabels;
    })

    this._langService.subscribeAlerts().subscribe((alerts) => {
      if (alerts) {
        this.alerts = alerts;
      }
    })
  }

  onSelectPremi() {
    this.user.pdv.preferenze.preferito = this.user.pdv.preferenze.ritiroPremi;
    this.user.pdv.preferenze.drive = "";
    let targetDrive = "";
    /* if (this.user.pdv.preferenze.ritiroPremi == "0033") {
      targetDrive = "drive-1" + this.user.pdv.preferenze.ritiroPremi.substr(-3 );
      //targetDrive = "1" + this.user.pdv.preferenze.ritiroPremi.substr(1, this.user.pdv.preferenze.ritiroPremi.length);

    }
    else {
      //targetDrive = "3" + this.user.pdv.preferenze.ritiroPremi.substr(1, this.user.pdv.preferenze.ritiroPremi.length);
      targetDrive = "drive-3" + this.user.pdv.preferenze.ritiroPremi.substr(-3 );

    } */
 
    for (let pdv of this.premiList)
      if (pdv.codePdv  == this.user.pdv.preferenze.ritiroPremi) {
        targetDrive = pdv.codPdvDrive;
        break;
      }

    for (let pdv of this.driveList)
      if (pdv.codPdvDrive == targetDrive) {
        this.user.pdv.preferenze.drive = targetDrive;
        break;
      }
  }


  getSalesPoint() {
    this._dataService.GetListLKPdv()
      .subscribe((list: Array<PuntoDiVendita>) => {
        if (list) {
          list.forEach((pdv: PuntoDiVendita) => {
            this.premiList.push(pdv)
            this.preferitoList.push(pdv);
            if (pdv.codPdvDrive)
              this.driveList.push({ "codPdvDrive": pdv.codPdvDrive, "descriptionPdvDrive": pdv.descriptionPdvDrive });
          })
          // this.user.pdv.preferenze.drive = "1033"
          this.onSelectPremi();
        }
      })
  }
  openRegolamentoBC() {
    //console.log(window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: ''));
		if (this.source == 'app') {
			if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
			 var iframe = document.createElement('iframe');
			iframe.height = "100%";
			iframe.width = "100%";
			iframe.src = "https://docs.google.com/gview?url=https://profilo.bennet.com/app/assets/data/regolamento_carta_bennet_club_2024.pdf&embedded=true";
			var ref = this._dialogService.openPDFDialog({
			  title: 'Modello registrazione - Privacy Bennet.com',
			  content: iframe,
			  footer: [],
			  source: this.source
			})
		  }
			else{
			  var anchor = document.createElement('a');
			//anchor.href = this.pathFile ;
      anchor.href =this.pathFileProdBC;
			anchor.download = 'Modello registrazione - Privacy Bennet.com.pdf';
			anchor.click();
			anchor.target='_blank'; 
	  
			}
		  }
		  else {
			var pdf = document.createElement('object');
			pdf.style.width = '100%';
			pdf.style.height = '100%';
			pdf.setAttribute('view', 'FitV')
			pdf.type = 'application/pdf';
			pdf.data = this.pathFileBC + "#view=FitH";
			var ref = this._dialogService.openPDFDialog({
			  title: 'Modello registrazione - Privacy Bennet.com',
			  content: pdf,
			  footer: [],
			  source: this.source
			})
		  }
		}
  openGDPRAgreement() {
    //console.log(window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: ''));
		if (this.source == 'app') {
			if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
			 var iframe = document.createElement('iframe');
			iframe.height = "100%";
			iframe.width = "100%";
			iframe.src = "https://docs.google.com/gview?url=https://profilo.bennet.com/app/assets/data/Informativa_trattamento_dati_03_2021.pdf&embedded=true";
			var ref = this._dialogService.openPDFDialog({
			  title: 'Modello registrazione - Privacy Bennet.com',
			  content: iframe,
			  footer: [],
			  source: this.source
			})
		  }
			else{
			  var anchor = document.createElement('a');
			//anchor.href = this.pathFile ;
      anchor.href =this.pathFileProd;
			anchor.download = 'Modello registrazione - Privacy Bennet.com.pdf';
			anchor.click();
			anchor.target='_blank'; 
	  
			}
		  }
		  else {
			var pdf = document.createElement('object');
			pdf.style.width = '100%';
			pdf.style.height = '100%';
			pdf.setAttribute('view', 'FitV')
			pdf.type = 'application/pdf';
			pdf.data = this.pathFile + "#view=FitH";
			var ref = this._dialogService.openPDFDialog({
			  title: 'Modello registrazione - Privacy Bennet.com',
			  content: pdf,
			  footer: [],
			  source: this.source
			})
		  }
		}

    getPremi(PremiCode): string {
      let Premi = this.premiList.find(premi => premi.codePdv == PremiCode);
      if (Premi){
        this.user.pdv.preferenze.ritiroPremi = Premi.codePdv;
  
        return Premi.descriptionPdv;
      }
    }
  
    getFavoriteMethod() {
      this._dataService.GetListLKMetodoPreferito()
        .subscribe((list) => {
          if (list)
            this.favoriteMethod = list;
        })
    }
    
    onSubmitBennetClub() {
      return new Promise((resolve, reject) => {
        const { drive, preferito, ritiroPremi } = this.user.pdv.preferenze
        if (!drive && this.source == "drive" || !drive && this.source == "drive-new") reject({ title: this.Labels.title_1, content: this.alerts.alert_24, btn: 'X' })
        if (!preferito) reject({ title: this.Labels.title_1, content: this.alerts.alert_25, btn: 'X' })
        if (!ritiroPremi) reject({ title: this.Labels.title_1, content: this.alerts.alert_26, btn: 'X' })
        if (!this.user.pdv.privacy[0].value)
          reject({ title: this.Labels.pvc0, content: this.alerts.alert_36, btn: 'X' })
        if (!this.user.pdv.privacy[1].value)
          reject({ title: this.Labels.pvc1, content: this.alerts.alert_36, btn: 'X' })
        if (!this.user.pdv.privacy[2].value)
          reject({ title: this.Labels.pvc2, content: this.alerts.alert_36, btn: 'X' })
        if (this.user.pdv.privacy[0].value != 'Y')
          reject({ title: "Privacy", content: this.alerts.alert_28, btn: 'X' })
        if (this.user.pdv.privacy[1].value == 'Y' && !this.user.pdv.privacy[1].favoriteMethod)
          reject({ title: "Marketing", content: this.alerts.alert_27, btn: 'X' })
        if (this.user.pdv.privacy[1].value == 'Y') {
          this.user.pdv.privacy[3].value = 'Y';
          this.user.pdv.privacy[4].value = 'Y';
          this.user.pdv.privacy[5].value = 'Y';
          this.user.pdv.privacy[6].value = 'Y';
          this.user.pdv.privacy[7].value = 'Y';
        }
        this._userService.setUser(this.user);
        resolve()
      })
    }
  }



// WEBPACK FOOTER //
// ./src/app/theme/components/slide4/slide4.component.ts